export const CHECKOUT_URL = 'https://mega-pack-macrame-desde-cero.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/jWmvW9GmUQEv3kitcCL7ia/Imagen_de_Codex_25_sept_2026,_19_08_14.png'

export const PRODUCT_NAME = 'MEGA PACK MACRAMÉ DESDE CERO'
export const PACK_IMAGE_ALT = 'MEGA PACK MACRAMÉ DESDE CERO: 6 tomos digitales y 5 bonos incluidos'
export const PRICE = '$19.990'
export const BONUS_TOTAL = '$39.950'

export const META_PIXEL_ID = '2226605141499138'

/* 1. PROBLEMA */
export const problems = [
  {
    emoji: '😵‍💫',
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardas videos, patrones e ideas, pero cada uno explica algo diferente y terminas sin saber cómo empezar una pieza.',
  },
  {
    emoji: '❓',
    title: 'NO SABES QUÉ APRENDER PRIMERO',
    desc: 'Cuerdas, medidas, nudos, patrones, terminaciones... hay tantas cosas que comenzar parece más complicado de lo que debería.',
  },
  {
    emoji: '🧶',
    title: 'TE FALTA UNA RUTA',
    desc: 'Tienes ganas de crear tus propias piezas, pero necesitas un camino que vaya desde los primeros nudos hasta proyectos completos.',
  },
  {
    emoji: '😩',
    title: 'SIGUES POSTERGANDO',
    desc: 'Ves diseños que te encantan, compras materiales o guardas ideas, pero pasan las semanas y todavía no sabes cómo convertirlas en tus propias creaciones.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    title: 'MACRAMÉ DESDE CERO',
    desc: 'Conoce los materiales, tipos de cuerdas, herramientas, medidas y preparación necesaria para comenzar correctamente.',
  },
  {
    title: 'NUDOS ESENCIALES',
    desc: 'Aprende los principales nudos del macramé, cómo realizarlos, combinarlos y utilizarlos dentro de diferentes diseños.',
  },
  {
    title: 'PROYECTOS PASO A PASO',
    desc: 'Lleva lo aprendido a la práctica creando tapices, portamacetas, llaveros y diferentes piezas decorativas.',
  },
  {
    title: 'MACRAMÉ MODERNO',
    desc: 'Avanza hacia bolsos, carteras, accesorios y diseños modernos utilizando nuevas combinaciones y estructuras.',
  },
  {
    title: 'TERMINACIONES PROFESIONALES',
    desc: 'Aprende a mejorar flecos, bordes, uniones, simetría y pequeños detalles que pueden cambiar completamente el resultado de una pieza.',
  },
  {
    title: 'MACRAMÉ PARA EMPRENDER',
    desc: 'Aprende a organizar tus productos, calcular costos, definir precios, fotografiar tus piezas y dar los primeros pasos para crear tu propio catálogo artesanal.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    title: '100 PATRONES Y PROYECTOS DE MACRAMÉ™',
    desc: 'Una biblioteca con 100 proyectos organizados por categorías y dificultad para que siempre tengas una nueva pieza para practicar y crear.',
    value: '$7.990',
  },
  {
    title: 'GUÍA MAESTRA DE NUDOS DE MACRAMÉ™',
    desc: 'Más de 30 nudos, variaciones y combinaciones explicados de manera visual para consultar cada vez que los necesites.',
    value: '$5.990',
  },
  {
    title: '50 PRODUCTOS DE MACRAMÉ PARA CREAR Y VENDER™',
    desc: '50 ideas organizadas para ayudarte a elegir piezas, crear colecciones y comenzar a construir tu primer catálogo artesanal.',
    value: '$6.990',
  },
  {
    title: 'CALCULADORA DE COSTOS, PRECIOS Y MATERIALES™',
    desc: 'Una guía práctica para organizar materiales, calcular cuánto cuesta cada pieza y establecer precios con mayor criterio.',
    value: '$8.990',
  },
  {
    title: 'KIT EMPRENDEDOR: DE TU PRIMERA PIEZA A TU PRIMER CATÁLOGO™',
    desc: 'Plantillas y recursos para organizar productos, fotografías, contenido, consultas y pedidos de tu emprendimiento artesanal.',
    value: '$9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    emoji: '🧶',
    title: 'MENOS CONFUSIÓN',
    desc: 'Deja de saltar entre tutoriales y sigue una ruta desde los materiales y primeros nudos hasta proyectos completos.',
  },
  {
    emoji: '✨',
    title: 'MÁS PRÁCTICA',
    desc: 'Aprende nudos, combinaciones, proyectos y terminaciones mientras avanzas paso a paso y a tu propio ritmo.',
  },
  {
    emoji: '🏡',
    title: 'CREA TUS PROPIAS PIEZAS',
    desc: 'Empieza a transformar cuerdas y materiales en tapices, portamacetas, accesorios, bolsos y decoración creada por ti.',
  },
  {
    emoji: '🚀',
    title: 'UNA NUEVA HABILIDAD',
    desc: 'Desarrolla conocimientos que puedes utilizar como pasatiempo creativo o como primer paso para construir un pequeño emprendimiento artesanal.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Tenía un montón de videos guardados y cada vez que intentaba empezar terminaba más confundida. Con los tomos ordenados entendí qué materiales necesitaba, qué nudos practicar primero y finalmente pude terminar mis primeras piezas.',
    author: 'Mariana López',
    meta: 'Emprendedora, 34 años · Buenos Aires, Argentina',
  },
  {
    quote:
      'Siempre veía tapices y portamacetas y pensaba que eran demasiado difíciles. Lo que más me ayudó fue poder avanzar desde los nudos básicos y después utilizarlos dentro de proyectos completos.',
    author: 'Carolina Méndez',
    meta: 'Aficionada al macramé, 29 años · Córdoba, Argentina',
  },
  {
    quote:
      'Había comprado cuerdas varias veces y terminaban guardadas porque no sabía calcular materiales ni qué proyecto elegir. Con el sistema pude organizarme mucho mejor y empezar por piezas sencillas.',
    author: 'Lucía Fernández',
    meta: 'Emprendedora, 38 años · Rosario, Argentina',
  },
  {
    quote:
      'Yo quería aprender macramé para tener una actividad creativa y quizás después vender algunas piezas. Me gustó que no se queda solamente en los nudos, sino que también explica proyectos, terminaciones y cómo organizar un catálogo.',
    author: 'Andrea Ramírez',
    meta: 'Emprendedora artesanal, 32 años · Santiago, Chile',
  },
  {
    quote:
      'El bono de costos fue de lo que más me sirvió. Antes miraba lo que cobraban otras personas y no sabía cuánto me costaba realmente hacer una pieza. Ahora tengo una forma mucho más ordenada de calcular materiales y organizar cada proyecto.',
    author: 'Sofía Martínez',
    meta: 'Artesana, 41 años · Montevideo, Uruguay',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El sistema comienza desde los materiales, las cuerdas y los primeros nudos, y avanza paso a paso hacia proyectos completos.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Materiales, tipos de cuerdas, medidas, nudos esenciales, proyectos paso a paso, macramé moderno, terminaciones profesionales y los primeros pasos para emprender con tus piezas.',
  },
  {
    q: '¿Incluye proyectos paso a paso?',
    a: 'Sí. Incluye tapices, portamacetas, llaveros, bolsos, accesorios y piezas decorativas, además de una biblioteca con 100 patrones y proyectos.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos GRATIS con tu compra durante esta oferta.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Realizas un único pago de $19.990. No hay mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Al completar tu compra recibirás acceso digital inmediato a los 6 tomos y los 5 bonos.',
  },
  {
    q: '¿Puedo utilizarlo si nunca hice macramé?',
    a: 'Sí. Está pensado para principiantes: comienzas con piezas sencillas y avanzas a medida que practicas y ganas confianza.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Puedes avanzar por los 6 tomos y utilizar los bonos siguiendo tu propio ritmo, sin horarios ni fechas límite.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Puedes escribirnos a soportescmdigital@gmail.com, el canal de soporte indicado al final de esta página.',
  },
]

/* POP-UP DE COMPRAS RECIENTES */
export const recentBuyers = [
  { name: 'Emily R.', city: 'Londres', country: 'Reino Unido', minutes: 2 },
  { name: 'Sarah M.', city: 'Toronto', country: 'Canadá', minutes: 4 },
  { name: 'Jessica T.', city: 'Austin', country: 'Estados Unidos', minutes: 7 },
  { name: 'Chloe W.', city: 'Sídney', country: 'Australia', minutes: 10 },
  { name: 'Olivia H.', city: 'Mánchester', country: 'Reino Unido', minutes: 13 },
  { name: 'Hannah L.', city: 'Vancouver', country: 'Canadá', minutes: 17 },
  { name: 'Ashley K.', city: 'Miami', country: 'Estados Unidos', minutes: 21 },
  { name: 'Grace P.', city: 'Melbourne', country: 'Australia', minutes: 26 },
  { name: 'Lauren B.', city: 'Denver', country: 'Estados Unidos', minutes: 32 },
  { name: 'Amelia S.', city: 'Edimburgo', country: 'Reino Unido', minutes: 38 },
  { name: 'Megan D.', city: 'Montreal', country: 'Canadá', minutes: 43 },
  { name: 'Ruby C.', city: 'Brisbane', country: 'Australia', minutes: 49 },
]
